import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import {
  Container,
  Form,
  Button,
  Segment,
  Message,
  Header,
} from 'semantic-ui-react'
import { SIGN_IN_MUTATION } from 'graphql/mutations'

class LoginForm extends Component {
  state = {
    email: '',
    password: '',
    message: '',
  }

  render() {
    const { email, password, message } = this.state
    return (
      <Container>
        <div style={{ maxWidth: 500, margin: '0 auto' }}>
          <Segment>
            <Header as="h1" content="Admin Login" />
            <Form>
              <Form.Input
                id="email"
                label="Email"
                onChange={event => this.setState({ email: event.target.value })}
                value={email}
              />
              <Form.Input
                id="password"
                label="Password"
                type="password"
                onChange={event =>
                  this.setState({ password: event.target.value })
                }
                value={password}
              />

              {message && (
                <Message>
                  <Message.Header>Error</Message.Header>
                  <p>{message}</p>
                </Message>
              )}

              <Mutation mutation={SIGN_IN_MUTATION}>
                {(signIn, { loading }) => {
                  return (
                    <Button
                      primary
                      loading={loading}
                      onClick={() => {
                        const variables = {
                          email: this.state.email,
                          password: this.state.password,
                        }
                        signIn({ variables })
                          .then(response => response.data.signin)
                          .then(signin => {
                            if (signin.state === 'admin') {
                              localStorage.setItem('token', signin.accessToken)
                              localStorage.setItem('ucn', signin.ucn)
                              localStorage.setItem(
                                'expirationTime',
                                signin.expirationTime,
                              )
                              this.props.history.push('/')
                            } else {
                              this.setState({
                                message: 'User lacks admin privileges',
                              })
                              console.error('User lacks admin privileges')
                            }
                          })
                          .catch(e => {
                            console.error('error signing in', e)
                            this.setState({ message: `${e.message}` })
                          })
                      }}
                    >
                      Sign in
                    </Button>
                  )
                }}
              </Mutation>
            </Form>
          </Segment>
        </div>
      </Container>
    )
  }
}

export default LoginForm
